import { taggedTemplateLiteral as _taggedTemplateLiteral } from '../../../_virtual/_rollupPluginBabelHelpers.js';
import styled from 'styled-components';
import { RADIO_TITLE_TYPOGRAPHY, RADIO_DIMENSIONS, DOT_DIMENSIONS, RADIO_LABEL_TYPOGRAPHY, RADIO_SIZES } from './RadioButton.constants.js';

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5;
var StyledRadioGroup = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n  gap: ", ";\n"])), function (_ref) {
  var theme = _ref.theme;
  return theme.sizing.small;
});
var RadioTitle = styled.h4(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  color: ", ";\n  ", "\n"])), function (_ref2) {
  var theme = _ref2.theme;
  return theme.colours.ink.primary.main;
}, function (_ref3) {
  var $size = _ref3.$size;
  return RADIO_TITLE_TYPOGRAPHY[$size];
});
var Radio = styled.input(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  -webkit-appearance: none;\n  appearance: none;\n  display: grid;\n  place-items: center;\n  ", "\n  cursor: ", ";\n\n  ", ";\n  ", "\n\n  ", ";\n  border-radius: ", ";\n  ", "\n\n  // hover styles - applied only when NOT disabled\n  ", "\n\n  &:focus-visible {\n    box-shadow: ", ";\n    outline: none;\n  }\n"])), function (_ref4) {
  var $size = _ref4.$size;
  return RADIO_DIMENSIONS[$size];
}, function (_ref5) {
  var disabled = _ref5.disabled;
  return disabled ? 'default' : 'pointer';
}, function (_ref6) {
  var theme = _ref6.theme,
    checked = _ref6.checked;
  return checked && "background-color: ".concat(theme.colours["interface"].main, ";");
}, function (_ref7) {
  var theme = _ref7.theme,
    checked = _ref7.checked,
    $size = _ref7.$size;
  return "\n      &::after {\n        content: '';\n        border-radius: ".concat(theme.borderRadius.ellipse, ";\n        background-color: ").concat(theme.colours.graphics.inverse.main, ";\n        transition: all 100ms ease-in-out;\n        ").concat(checked ? DOT_DIMENSIONS[$size] : "\n              width: 0;\n              height: 0;\n            ", "\n      }\n  ");
}, function (_ref8) {
  var theme = _ref8.theme,
    checked = _ref8.checked,
    disabled = _ref8.disabled;
  return !checked && disabled && "background-color: ".concat(theme.colours.layering[0].main, ";");
}, function (_ref9) {
  var theme = _ref9.theme;
  return theme.borderRadius.ellipse;
}, function (_ref10) {
  var theme = _ref10.theme,
    checked = _ref10.checked;
  return !checked && "border: ".concat(theme.sizing.xtiny, " solid ").concat(theme.colours.layering[0].main, ";");
}, function (_ref11) {
  var _ref11$theme = _ref11.theme,
    colours = _ref11$theme.colours,
    sizing = _ref11$theme.sizing,
    disabled = _ref11.disabled,
    checked = _ref11.checked;
  return !disabled && "\n    &:hover {\n      ".concat(checked ? "background-color: ".concat(colours["interface"].strong, ";") : "border: ".concat(sizing.xtiny, " solid ").concat(colours.layering[0].strong, ";"), "\n    }\n  ");
}, function (_ref12) {
  var theme = _ref12.theme;
  return theme.effects.focus;
});
var RadioRow = styled.div(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: flex-start;\n  gap: ", ";\n  ", "\n"])), function (_ref13) {
  var theme = _ref13.theme;
  return theme.sizing.small;
}, function (_ref14) {
  var theme = _ref14.theme,
    $disabled = _ref14.$disabled;
  return $disabled && "opacity: ".concat(theme.opacity.disabled, ";");
});
var RadioLabel = styled.label(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n  ", "\n  cursor: ", ";\n  color: ", ";\n  padding-top: ", ";\n"])), function (_ref15) {
  var $size = _ref15.$size;
  return RADIO_LABEL_TYPOGRAPHY[$size];
}, function (_ref16) {
  var $disabled = _ref16.$disabled;
  return $disabled ? 'default' : 'pointer';
}, function (_ref17) {
  var theme = _ref17.theme;
  return theme.colours.ink.primary.main;
}, function (_ref18) {
  var theme = _ref18.theme,
    $size = _ref18.$size;
  return $size === RADIO_SIZES.REGULAR ? theme.sizing.xtiny : '';
});

export { Radio, RadioLabel, RadioRow, RadioTitle, StyledRadioGroup };
//# sourceMappingURL=RadioButton.styles.js.map
